import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import messages from './messages';
import style from './style.module.css';
import { FormattedMessage } from 'react-intl';

const FedexHalShipmentTooltip = ({ iconClassName, iconContainerClassName, isAddressTooltip = false }) => {
  const header = isAddressTooltip ? messages.addressHeader : messages.carrierHeader;
  const body = isAddressTooltip ? messages.addressBody : messages.carrierBody;

  return (
    <Tooltip>
      <div className={iconContainerClassName}>
        <FontAwesomeIcon className={classnames(style.icon, iconClassName)} icon={faInfoCircle} />
      </div>
      <TooltipContent>
        <div className={style['tooltip-header']}>
          <FormattedMessage {...header} />
        </div>
        <FormattedMessage {...body} />
      </TooltipContent>
    </Tooltip>
  );
};

export default FedexHalShipmentTooltip;

FedexHalShipmentTooltip.propTypes = {
  iconClassName: PropTypes.string,
  iconContainerClassName: PropTypes.string,
  isAddressTooltip: PropTypes.bool,
};
